import { configureStore } from '@reduxjs/toolkit';
import { rootReducer } from "./rootReducer";
export var createStore = function createStore() {
  return configureStore({
    reducer: rootReducer,
    middleware: function middleware(getDefaultMiddleware) {
      return getDefaultMiddleware();
    },
    devTools: {
      name: '@BEEF/SIDE-MENU'
    }
  });
};
export var sideMenuStore = createStore();